import { keysToSnakeCaseDeep } from '@agro1desenvolvimento/utils-js';
import { Operacao, StatusOperacao } from '../@types';
import aqilaApi from './aqila-api';

export type UsuarioResumo = {
  id: number;
  nome: string;
  nomeCompleto: string;
};

export type OperacaoToSave = {
  descricao: string;
  statusOperacao: StatusOperacao;
  grupoMaquinas: number[];
  grupoInsumos: { tipo: number; codigo: number }[];
  ordemAplicacao: number;
};

class Operacoes {
  private readonly endpoint = 'v1/operacoes';

  readonly STATUS_OPERACOES = <const>['D', 'S', 'T', 'A', 'C', 'N', 'P', 'L'];

  readonly STATUS_OPERACOES_HUMANIZED = <const>{
    D: 'Defensivos',
    S: 'Semeadura',
    T: 'Tratamento de Sementes',
    A: 'Adub. Base/Cobertura',
    C: 'Correção Solo/Adub. Sistema',
    N: 'Outra Agrícola',
    P: 'Pecuária',
    L: 'Leiteira',
  };

  async list() {
    const { data } = await aqilaApi.get<Operacao[]>(`${this.endpoint}`, {
      params: { operacao: 'all' },
    });
    return data;
  }

  async find(id: string) {
    const { data } = await aqilaApi.get<Operacao>(`${this.endpoint}/${id}`);

    return data;
  }

  async create(record: OperacaoToSave) {
    await aqilaApi.post(
      this.endpoint,
      keysToSnakeCaseDeep({ operacao: record }),
    );
  }

  async update(record: OperacaoToSave & { id: string }) {
    await aqilaApi.patch(
      `${this.endpoint}/${record.id}`,
      keysToSnakeCaseDeep({ operacao: record }),
    );
  }

  async delete(id: string) {
    await aqilaApi.delete(`${this.endpoint}/${id}`);
  }

  async usuariosAtivos() {
    const { data } = await aqilaApi.get<UsuarioResumo[]>('v1/usuarios', {
      params: { ativo: true },
    });
    return data;
  }
}

export default new Operacoes();
